export default __webpack_public_path__ + "static/media/project7.60205dc3.webp";